import {
  CardElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { useState } from 'react';
import { Button, Input } from '@heroui/react';

const CheckoutForm = ({upgradeCampaign, amount, userid}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [code, setCode] = useState();
  const [error, setError] = useState();

  const handleUpgradeSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();
    let fd = new FormData();
    fd.append('amount', amount);
    fd.append('campaign_id', upgradeCampaign._id);
    fd.append('user_id', userid);
    const intent = await fetch(`/api/v1/payments`, {method: 'POST', body: fd});
    const intentData = await intent.json();
    console.log('Intent Data:');
    console.log(intentData);

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      alert("Stripe not loaded!");
      return;
    }   

    const card = elements.getElement('card');
    card.mount('#card-element');
    const secret = intentData.client_secret;
    const result = await stripe.confirmCardPayment(
      secret,
      {
        payment_method: {
          card: card,
          /* billing_details: {
            campaign_id: upgradeCampaign._id,
          } */
        }
      }
    ); 
    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      // console.log(result.error.message);
      setError(result.error.message);
      alert(result.error.message);
    } else {
      alert('Payment received successfully.');
      window.location.reload();
    }   
  }

  const submitCode = async () => {
    let fd = new FormData();
    fd.append('key', code);
    const d = await fetch(`/api/v1/campaign/${upgradeCampaign._id}/apply_discount_code`,
      {method: 'PUT', body: fd});
    if (d.status === 200) {
      alert('Discount code applied!');
      window.location.reload();
    } else {
      const djson = await d.json();
      if (djson.error) {
        setError(djson.error);
      } else {
        setError('Invalid discount code');
      }
    }
    return false;
  };

  return (
    <form onSubmit={handleUpgradeSubmit}>
      <CardElement id='card-element' />
      <br />
      <div style={{display: 'flex',  position: 'absolute', right: '4px', bottom: '140px', paddingRight: '22px'}}>
        <Button color="danger" variant="light" onPress={() => window.location.reload()}>
          Cancel
        </Button>
        <Button color="primary" type="submit">
          Submit Payment
        </Button>
      </div>
      <hr style={{height: '4px', marginTop: '70px', marginBottom: '10px'}} />
      <div style={{padding: '12px', borderRadius: '8px', width: '100%'}}>
        <div style={{color: '#ff0000', marginBottom: '4px'}}>{error}</div>
        <div style={{width: '280px', display: 'inline-block', marginRight: '8px'}}>
          <Input variant='bordered' size='sm' fullWidth='true' onChange={(e) => setCode(e.target.value)}
                 className='max-w-[280px]' label='Discount Code' type='string' />
        </div>
        <div style={{width: '40px', position: 'absolute', display: 'inline-block', marginTop: '4px'}}>
          { code &&  <Button onPress={(e) => submitCode(e)} color="primary">Apply</Button> }
        </div>
      </div>
    </form>
  );
};

export default CheckoutForm;
